// eslint-disable-next-line no-unused-vars
import { Fragment, h, createRef } from 'preact';
import PropTypes from 'prop-types';
import Item from './Item';

/**
 * List component.
 * Default way to show short list options.
 *
 * @param {object} props Props
 * @param {string} props.type The input type.
 * @param {Array} props.items The array of item objects.
 * @param {string} props.name The input name.
 * @returns {object} JSX
 */
const List = ( { type, items, name } ) => {
	return (
		<ul className="facet facet--list pl-0">
			{items.map( ( item ) => {
				return <Item item={item} key={item.id} group={name} type={type} />;
			} )}
		</ul>
	);
};

List.propTypes = {
	type: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
	name: PropTypes.string.isRequired,
};

export default List;
